/**
 * Global snackbar store for displaying stacked notifications via EgovSnackbar.vue.
 *
 * Usage:
 *   const snackbar = useSnackbarStore()
 *
 *   snackbar.add({ type: 'success', description: 'Saved!' })
 *   snackbar.add({ type: 'error', description: 'Something went wrong.', timeout: 4000 })
 *   snackbar.clear() // call in onUnmounted to clear notifications when leaving a page
 *
 * type: 'info' | 'success' | 'warning' | 'error'  (default: 'info')
 * timeout: ms before auto-dismiss — omit or pass null to require manual close
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSnackbarStore = defineStore('snackbar', () => {
  const notifications = ref([])

  const add = ({ type = 'info', description, timeout = null }) => {
    const id = crypto.randomUUID()

    notifications.value.push({ id, type, description, timeout })

    if (timeout) {
      setTimeout(() => remove(id), timeout)
    }
    return id
  }

  const remove = (id) => {
    notifications.value = notifications.value.filter((n) => n.id !== id)
  }

  const clear = () => {
    notifications.value = []
  }

  return { notifications, add, remove, clear }
})
